var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHandshake = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333132",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M45.131 22.838 40.5 25.144l-6-11.475 4.688-2.344a1.48 1.48 0 0 1 1.987.638l4.613 8.83a1.5 1.5 0 0 1-.657 2.044"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m7.5 24.956-4.632-2.325a1.48 1.48 0 0 1-.656-2.025l4.613-8.831a1.5 1.5 0 0 1 1.987-.656l4.688 2.344zM40.5 25.144l-3 3.525-6.9 6.9a1.6 1.6 0 0 1-1.425.393L18.3 33.245a1.5 1.5 0 0 1-.544-.282L7.5 24.957"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m37.5 28.669-8.25-6-2.4 1.8a6.02 6.02 0 0 1-7.2 0l-1.012-.769a1.518 1.518 0 0 1-.17-2.269l7.35-7.331a1.48 1.48 0 0 1 1.05-.431H34.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m13.612 13.463 9.62-2.813a1.5 1.5 0 0 1 1.03.075l6.488 2.944M21 39.919l-5.644-1.425a1.4 1.4 0 0 1-.618-.319L10.5 34.5"
})));
export default SvgHandshake;